import { instance } from "apis/interceptor";

type ResponseType<T> = {
  success: boolean;
  statusCode?: number;
  message?: string;
  data?: T;
};

export enum AlarmChannel {
  EMAIL = "EMAIL",
  SLACK = "SLACK",
}

export type TAlarm = {
  isMeetingRsvAlarmEnabled: boolean;
  meetingRsvAlarmChannel: AlarmChannel;
  isMeetingAlarmEnabled: boolean;
  meetingAlarmChannel: AlarmChannel;
  isMeetingExtendAlarmEnabled: boolean;
  meetingExtendAlarmChannel: AlarmChannel;
  isMeetingAlarmEnabledByAdmin: boolean;
  meetingUsageConfirmAlarmChannel: AlarmChannel;
  meetingRoomComplainHostAlarmInfo: {
    id: string;
    hostAlarmChannel: AlarmChannel;
  };
  meetingRoomDeviceHostAlarmInfo: {
    id: string;
    hostAlarmChannel: AlarmChannel;
  }
};

//FEAT: (new) 내 알림 설정 조회
export async function getAlarmSettings(): Promise<ResponseType<TAlarm>> {
  try {
    const res = await instance.get("/alarm-settings");
    return { success: true, data: res.data };
  } catch (error: any) {
    return { success: false };
  }
}

//UPDATE: (new) 예약 알림 수신 여부 설정
export async function updateMeetingRsvAlarm(isMeetingRsvAlarmEnabled: boolean): Promise<ResponseType<boolean>> {
  try {
    const res = await instance.patch(`/alarm-settings/meeting-rsv-alarm`, {
      isMeetingRsvAlarmEnabled: isMeetingRsvAlarmEnabled,
    });
    return { success: res.data.result, message: "" };
  } catch (error: any) {
    return { success: false, message: "설정 변경에 실패했습니다. 다시 시도해 주세요." };
  }
}

//UPDATE: (new) 회의 알림 수신 여부 설정
export async function updateMeetingAlarm(isMeetingAlarmEnabled: boolean): Promise<ResponseType<boolean>> {
  try {
    const res = await instance.patch(`/alarm-settings/meeting-alarm`, {
      isMeetingAlarmEnabled: isMeetingAlarmEnabled,
    });
    return { success: res.data.result, message: "" };
  } catch (error: any) {
    return { success: false, message: "설정 변경에 실패했습니다. 다시 시도해 주세요." };
  }
}

//UPDATE: (new) 연장 알림 수신 여부 설정
export async function updateMeetingExtendAlarm(isMeetingExtendAlarmEnabled: boolean): Promise<ResponseType<boolean>> {
  try {
    const res = await instance.patch(`/alarm-settings/meeting-extend-alarm`, {
      isMeetingExtendAlarmEnabled: isMeetingExtendAlarmEnabled,
    });
    return { success: res.data.result, message: "" };
  } catch (error: any) {
    return { success: false, message: "설정 변경에 실패했습니다. 다시 시도해 주세요." };
  }
}

//UPDATE: (new) 예약 알림 수신 채널 설정
export async function updateMeetingRsvAlarmChannel(
  meetingRsvAlarmChannel: AlarmChannel
): Promise<ResponseType<boolean>> {
  try {
    const res = await instance.patch(`/alarm-settings/meeting-rsv-alarm/channel`, {
      meetingRsvAlarmChannel: meetingRsvAlarmChannel,
    });
    return { success: res.data.result, message: "" };
  } catch (error: any) {
    return { success: false, message: "설정 변경에 실패했습니다. 다시 시도해 주세요." };
  }
}

//UPDATE: (new) 회의 알림 수신 채널 설정
export async function updateMeetingAlarmChannel(meetingAlarmChannel: AlarmChannel): Promise<ResponseType<boolean>> {
  try {
    const res = await instance.patch(`/alarm-settings/meeting-alarm/channel`, {
      meetingAlarmChannel: meetingAlarmChannel,
    });
    return { success: res.data.result, message: "" };
  } catch (error: any) {
    return { success: false, message: "설정 변경에 실패했습니다. 다시 시도해 주세요." };
  }
}

//UPDATE: (new) 연장 알림 수신 채널 설정
export async function updateMeetingExtendAlarmChannel(
  meetingExtendAlarmChannel: AlarmChannel
): Promise<ResponseType<boolean>> {
  try {
    const res = await instance.patch(`/alarm-settings/meeting-extend-alarm/channel`, {
      meetingExtendAlarmChannel: meetingExtendAlarmChannel,
    });
    return { success: res.data.result, message: "" };
  } catch (error: any) {
    return { success: false, message: "설정 변경에 실패했습니다. 다시 시도해 주세요." };
  }
}

//* INFO: 알림 설정 - 회의실 이용 확인 알림 채널 수정
export const updateMeetingRoomUsageConfirmAlarmChannel = async (channel: AlarmChannel) => {
  try {
    const res = await instance.patch("/alarm-settings/meeting-usage-confirm-alarm/channel", {
      meetingUsageConfirmAlarmChannel: channel,
    });
    return { success: res.data.result, message: "변경사항이 성공적으로 저장되었습니다." };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else {
      return { success: false, message: "변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요." };
    }
  }
};
